import { Layout, locale, util } from '@glu/core';
import FlexDropdown from '@glu/flex-dropdown';
import AddNewView from './components/addNewView';
import DropdownItemView from './components/dropdownItemView';

import template from './savedViews.hbs';

export default Layout.extend({
  template,

  collectionEvents: {
    add: 'updateDropdownAndSetSelected',
    reset: 'updateDropdownAndSetDefault',
    remove: 'updateDropdown'
  },

  regions: {
    select: '.region-grid-select-saved-view'
  },

  initialize(options) {
    this.grid = options.grid;

    this.listenTo(this.grid, 'change:state', this.onStateChanged);
  },

  initializeDropdown() {
    this.closeDropdown();
    this.dropdown = this.createDropdown();
  },

  onClose() {
    this.closeDropdown();
  },

  closeDropdown() {
    if (this.dropdown) {
      this.dropdown.close();
      this.dropdown = null;
    }
  },

  createDropdown() {
    const selectedValue = this.grid.stateModel.get('id');
    const { grid } = this.options;

    const flexDropdownOptions = {
      data: this.getDropDownData(),
      filter: false,
      multiSelect: false,
      preSelectedIds: selectedValue ? [selectedValue] : [],
      defaultSelectMessage: locale.get('selectView'),
      label: locale.get('savedViews'),
      showTooltip: false,
      showCancelIcon: false,
      clearBtn: false,
      disableMultiButton: true,
      disabled: false,
      customView: AddNewView,
      customViewOptions: {
        grid: this.options.grid,
        savedViewsCollection: this.collection
      },
      dropDownItemView: {
        viewClass: DropdownItemView,
        viewOptions: {
          savedViewsCollection: this.collection
        }
      },
      dataQA: `${grid.options.id}-saved-views-dropdown`
    };

    const dropdown = new FlexDropdown(flexDropdownOptions);

    this.listenTo(dropdown, 'selectionChanged:id', this.handleSelectView);

    return dropdown;
  },

  handleSelectView(ids) {
    const id = ids[0];

    if (!id) {
      return this.trigger('grid:use:savedView', this.collection.getDefaultModel());
    }

    // if selectedViewId is the same then we shouldn't update grid.
    if (id === this.grid.stateModel.get('id') && !this.stateChanged) {
      return;
    }

    this.stateChanged = false;
    this.trigger('grid:use:savedView', this.collection.get(id));
  },

  onBeforeRender() {
    this.initializeDropdown();
  },

  onRender() {
    this.showDropdown();
  },

  showDropdown() {
    this.select.show(this.dropdown);
    this.enableDropdown();
  },

  enableDropdown() {
    if (!this.collection.isEmpty()) {
      return;
    }

    // only if we don't have previous saved views.
    this.$('.selection').removeClass('disabled');
  },

  openDropdown() {
    util.defer(() => {
      if (this.dropdown) {
        this.dropdown.openDropdown();
      }
    });
  },

  getDropDownData() {
    return this.collection.map(this.buildDropDownItem, this);
  },

  buildDropDownItem(item) {
    const id = item.get('id');
    const isChanged = (this.grid.stateModel.get('id') === id && this.stateChanged);
    const name = item.get('name');

    return {
      isChanged,
      id,
      name: isChanged ? locale.get('savedViews.viewChanged', name) : name,
      defaultName: name
    };
  },

  updateDropdownAndSetSelected(addedModel) {
    if (!this.dropdown) {
      return;
    }

    this.stateChanged = false;
    this.updateDropdown();
    this.dropdown.setSelectedIds(addedModel.get('id'));
  },

  updateDropdownAndSetDefault() {
    if (!this.dropdown) {
      return;
    }

    this.updateDropdown();

    const defaultModel = this.collection.getDefaultModel();
    if (defaultModel) {
      this.dropdown.setSelectedIds(defaultModel.get('id'));
    }
  },

  updateDropdown() {
    if (!this.dropdown) {
      return;
    }

    if (this.collection.isEmpty()) {
      return this.render();
    }

    this.dropdown.setData(this.getDropDownData());
  },

  onStateChanged(state) {
    if (!this.grid.stateModel.get('id')) {
      return;
    }

    this.stateChanged = !util.isEqual(this.collection.get(state.id), state);
    this.updateDropdown();
  }
});
